module.exports = __webpack_public_path__ + "media/bootstrap-icons/align-bottom-26178b9c.svg";